import { saveOfflineEntry, isCacheableUrl, cacheApiResponse, getCachedResponse } from './offlineDB';
import { toast } from 'sonner';

export function createOfflineAwareApi(api) {
  if (!api) return api;

  const originalPost = api.post.bind(api);
  const originalGet = api.get.bind(api);

  const wrappedApi = Object.create(api);

  // Store reference to the raw (unwrapped) api for sync operations
  wrappedApi._rawApi = api;

  wrappedApi.post = async function(url, data, config) {
    try {
      return await originalPost(url, data, config);
    } catch (error) {
      // Only save offline if it's a network error (not a server validation error)
      if (!navigator.onLine || error.message === 'Network Error' || !error.response) {
        const entryType = url.startsWith('/') ? url.slice(1) : url;
        await saveOfflineEntry({ entry_type: entryType, payload: data });
        toast("Offline: Entry saved locally. Will auto-sync when online.", { icon: "📴" });
        return { data: { offline: true, message: 'Offline saved. Will sync when online.' } };
      }
      throw error;
    }
  };

  wrappedApi.get = async function(url, config) {
    try {
      const response = await originalGet(url, config);
      // Cache successful responses for offline use
      if (isCacheableUrl(url)) {
        cacheApiResponse(url, response.data);
      }
      return response;
    } catch (error) {
      // If offline or network error, try serving from cache
      if (!navigator.onLine || error.message === 'Network Error' || !error.response) {
        const cached = await getCachedResponse(url);
        if (cached) {
          return { data: cached, _fromCache: true };
        }
      }
      throw error;
    }
  };

  return wrappedApi;
}
